import { render, staticRenderFns } from "./ProgressReportWidget.vue?vue&type=template&id=a32c3f00&"
import script from "./ProgressReportWidget.vue?vue&type=script&lang=js&"
export * from "./ProgressReportWidget.vue?vue&type=script&lang=js&"
import style0 from "./ProgressReportWidget.vue?vue&type=style&index=0&id=a32c3f00&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports